
import React, { useEffect, useState } from "react";
import { Gara } from "../types/gare/gara";
import { GaraService } from "../services/garaService";
import ClassificaTab from "../components/ClassificaTab";
import ClassificaCoppie from "./classifiche/ClassificaCoppie";

interface ClassificaTabWrapperProps {
  gara: Gara;
  typeId: number;
}


const ClassificaTabWrapper: React.FC<ClassificaTabWrapperProps> = ({ gara, typeId }) => {
  const [updatedGara, setUpdatedGara] = useState<Gara>(gara);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    GaraService.getGaraById(gara.id)
      .then((data) => {
        if (isMounted) setUpdatedGara(data);
      })
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, [gara.id]);

  if (loading) return <div>Caricamento classifica aggiornata...</div>;

  switch (typeId) {
    case 1:
      return (
        <ClassificaTab
          sections={updatedGara.sections}
          concorrenti={updatedGara.competitors}
          competitionName={updatedGara.name}
          competitionDate={updatedGara.competitionDate}
        />
      );
    case 2:
      return (
        <ClassificaCoppie
          sections={updatedGara.sections}
          concorrenti={updatedGara.competitors}
          competitionName={updatedGara.name}
          competitionDate={updatedGara.competitionDate}
        />
      );
    case 3:
      return (
        <ClassificaCoppie
          sections={updatedGara.sections}
          concorrenti={updatedGara.competitors}
          competitionName={updatedGara.name}
          competitionDate={updatedGara.competitionDate}
        />
      );
    default:
      return <div>Tipo gara non supportato</div>;
  }
};

export default ClassificaTabWrapper;
